// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
// const BASE_URL = "http://localhost:4000";
const BASE_URL = process.env.REACT_APP_API_URL;

export default BASE_URL;